<template>
<div>
    <div class="card">

        <div class="card-body">
            <h4>Filter Validators</h4>
            <div class="d-flex justify-content-around">
                <div>
                    <h4>Find Validators By Name</h4>
                    <b-form-input v-model="searchText" placeholder="Search by name"></b-form-input>
                </div>
                <div>
                    <h4>Sort By</h4>
                    <b-form-select v-model="sortBy" :options="sortOptions"></b-form-select>
                </div>
                <div>
                    <h4>Sort Direction</h4>
                    <b-form-select v-model="sortDesc" :options="sortDirectionOptions"></b-form-select>
                </div>
                <!--            <h4>Find By Tag</h4>
                            <el-select v-model="selectedFlags" multiple filterable placeholder="Please select">
                                <el-option
                                        v-for="item in flags"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>-->
            </div>
        </div>
    </div>
    <b-table :items="filteredValidators"
             :fields="[
                    { key: 'name', label: 'Name', sortable: true },

                    { key: 'active_stake', label: 'Stake', sortable: true },
                    { key: 'apy', label: 'APY', sortable: true },
                    { key: 'score', label: 'Score', sortable: true },
                    { key: 'details', label: 'Details' },

                ]"
             class="lead font-weight-normal   "
             td-class="align-middle"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"

    >
        <template v-slot:cell(rank)="data">
            <span class="text-success">{{ data.item.rank }}</span>
        </template>
        <template v-slot:cell(name)="data">
            <a :href="'/validators/' + data.item.vote_account" class=""><img :src="data.item.avatar_url" class="img-fluid brround mx-5" :alt="data.item.name" style="max-width:100px">
                <span class="ml-3 pl-3">{{ data.item.shortName }}</span>
                <span v-if="data.item.jito" class="badge badge-sm small  text-sm bg-success" style="margin-left:15px;
    font-size: .7rem;
    padding: 2px 4px;"
                title="Stakers to this validator receive extra yield from Jito's MEV tips"
                >+mev</span>
            </a>
        </template>
        <template v-slot:cell(flags)="data">
            <span v-for="flag in data.item.flags" class="badge badge-primary">{{ flag }}</span>
        </template>
        <template v-slot:cell(score)="data">
            <h1 class="text-success mb-0">{{ Number(data.item.score_percent).toFixed(1) }}%</h1>
        </template>
        <template v-slot:cell(active_stake)="data">
            <div class="align-middle h-100">
                {{ Math.floor(data.item.active_stake/1e9).toLocaleString() }} SOL
            </div>
        </template>
        <template v-slot:cell(apy)="data">
            {{ (data.item.apy*100).toFixed(1) }}%
        </template>
        <template v-slot:cell(details)="data">
            <a :href="'/validators/' + data.item.vote_account" class="btn btn-success btn-lg">Details</a>
        </template>
    </b-table>
    <b-pagination v-model="currentPage" :total-rows="filteredValidators.length" :per-page="perPage" class="my-0" aria-controls="my-table"></b-pagination>
</div>
</template>

<script>
export default {
    name: "ValidatorsTable",
    props: ['validators'],
    data() {
        return {
            perPage: 50,
            currentPage: 1,
            sortBy: 'score',
            sortDesc: true,
            searchText:'',
            selectedTags: [],
            flags: [
                /*  'excessive_commission', //danger
        'zero_commission',
        'low_software_version',
        'low_published_information',
        'high_stake_concentration',
        'high_data_center_concentration',
        'extreme_data_center_concentration',
        'delinquent',
        "SLOW_VOTER",
        "BLACKLIST_COMMISSION_RUG",
        'high_commission' // warning
        */
                {value: 'excessive_commission', label: 'Excessive Commission'},
                {value: 'zero_commission', label: 'Zero Commission'},
                {value: 'low_software_version', label: 'Low Software Version'},
                {value: 'low_published_information', label: 'Low Published Information'},
                {value: 'high_stake_concentration', label: 'High Stake Concentration'},
                {value: 'high_data_center_concentration', label: 'High Data Center Concentration'},
                {value: 'extreme_data_center_concentration', label: 'Extreme Data Center Concentration'},
                {value: 'delinquent', label: 'Delinquent'},
                {value: 'SLOW_VOTER', label: 'Slow Voter'},
                {value: 'BLACKLIST_COMMISSION_RUG', label: 'Blacklist Commission Rug'},
                {value: 'high_commission', label: 'High Commission'},



            ],
            sortOptions: [
                {value: 'name', text: 'Name'},
                {value: 'active_stake', text: 'Stake'},
                {value: 'score', text: 'Total Score'},
                {value: 'apy', text: 'APY'},
                {value: 'weighted_scores.skippedSlotPercent', text: 'Skipped Slots Performance'},
                {value: 'weighted_scores.epochCredits', text: 'Vote Credits Performance'},
                {value: 'weighted_scores.cu', text: 'Compute Unit Performance'},
                {value: 'weighted_scores.txns', text: 'Transactions/Block Performance'},
                {value: 'weighted_scores.rootDistance', text: 'Root Distance Performance'},
                {value: 'weighted_scores.uptime', text: 'Uptime Performance'},
            ],
            sortDirectionOptions: [
                {value: true, text: 'Descending'},
                {value: false, text: 'Ascending'},
            ]
        }
    },
    mounted() {

    },
    computed: {
        filteredValidators() {
            let filteredValidators = this.validators
            if (this.searchText) {
                filteredValidators = filteredValidators.filter(validator => {
                    let name = (validator.name || '').toLowerCase() + ' ' + (validator.account || '').toLowerCase() + ' ' + (validator.vote_account || '').toLowerCase()
                    return name.toLowerCase().includes(this.searchText.toLowerCase())
                })
            }
            return filteredValidators
        }
    }
}
</script>

<style scoped>

</style>
